import { __assign, __makeTemplateObject, __read, __spread } from "tslib";
import React, { useState, useCallback } from 'react';
import { css } from 'styled-components';
import Collapse from '../Collapse';
import { createComponent } from '../utils';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Flex } from '../Flex';
var AccordionContainer = createComponent({
    name: 'Accordion',
});
var AccordionItemContainer = createComponent({
    name: 'AccordionItem',
});
var AccordionHeader = createComponent({
    name: 'AccordionItemHeader',
    tag: 'header',
    style: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0.75rem 1rem;\n    cursor: pointer;\n  "], ["\n    padding: 0.75rem 1rem;\n    cursor: pointer;\n  "]))),
});
var AccordionTitle = createComponent({
    name: 'AccordionItemTitle',
    tag: 'span',
    style: css(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))),
});
var AccordionIcon = createComponent({
    name: 'AccordionItemIcon',
    as: Icon,
    style: function (_a) {
        var isOpen = _a.isOpen;
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    transition: 175ms transform;\n    transform: rotate(", "deg);\n  "], ["\n    transition: 175ms transform;\n    transform: rotate(", "deg);\n  "])), isOpen ? 90 : 0);
    },
});
var AccordionContent = createComponent({
    name: 'AccordionItemContent',
});
var AccordionItem = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, content = _a.content, contentContainerStyle = _a.contentContainerStyle, renderHeader = _a.renderHeader, renderContent = _a.renderContent, onToggle = _a.onToggle;
    return (React.createElement(AccordionItemContainer, null,
        React.createElement(Collapse, { isOpen: isOpen, renderTrigger: function () {
                return renderHeader ? (renderHeader({ isOpen: isOpen, title: title, onToggle: onToggle })) : (React.createElement(AccordionHeader, { onClick: onToggle },
                    React.createElement(Flex, null,
                        React.createElement(Box, { flex: 1 },
                            React.createElement(AccordionTitle, null, title)),
                        React.createElement(AccordionIcon, { name: "chevron-right", isOpen: isOpen }))));
            } }, renderContent ? (renderContent({ isOpen: isOpen, content: content })) : (React.createElement(AccordionContent, { style: contentContainerStyle }, content)))));
};
var Accordion = function (_a) {
    var items = _a.items, solo = _a.solo, contentContainerStyle = _a.contentContainerStyle, children = _a.children;
    var _b = __read(useState([]), 2), openList = _b[0], setOpenList = _b[1];
    var handleItemToggle = useCallback(function (idx) {
        if (openList.indexOf(idx) >= 0) {
            setOpenList(openList.filter(function (i) { return i !== idx; }));
        }
        else {
            setOpenList(solo ? [idx] : __spread(openList, [idx]));
        }
    }, [solo, openList]);
    return (React.createElement(AccordionContainer, null, children ||
        items.map(function (item, i) { return (React.createElement(AccordionItem, __assign({ key: item.title, contentContainerStyle: contentContainerStyle }, item, { isOpen: openList.indexOf(i) >= 0, onToggle: function () { return handleItemToggle(i); } }))); })));
};
Accordion.Item = AccordionItem;
export default Accordion;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Accordion.js.map